var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:[_vm.$style.imageContainer]},[_c('Block',{attrs:{"block":_vm.block.innerBlocks[0],"lazy":_vm.lazy}})],1),_c('Block',{class:_vm.$style.heading,attrs:{"block":_vm.block.innerBlocks[1]}}),_vm._l((_vm.filteredInnerBlocks),function(innerBlock,key){return _c('Block',{key:`imageTextBlock${key}`,attrs:{"block":innerBlock}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }